export const DEFAULT_STORE_FONT = 'athletic-block';

export const STORE_NAME_NUMBER_FONTS = [
  { id: 'athletic-block', label: 'Athletic Block (Anton)' },
  { id: 'script', label: 'Script (Pacifico)' },
  { id: 'zeroathletics', label: 'Zero Athletics' },
  { id: 'modern', label: 'Modern (Helvetica Neue)' },
] as const;

export type StoreNameNumberFont = (typeof STORE_NAME_NUMBER_FONTS)[number]['id'];

export function isStoreNameNumberFont(id?: string | null): id is StoreNameNumberFont {
  return STORE_NAME_NUMBER_FONTS.some((f) => f.id === String(id || '').trim());
}

export function normalizeStoreFont(id?: string | null, fallback: StoreNameNumberFont = DEFAULT_STORE_FONT): StoreNameNumberFont {
  const raw = String(id || '').trim();
  return isStoreNameNumberFont(raw) ? raw : fallback;
}
